import React, { useMemo } from 'react';

import ScreenSelect from 'components/ScreensPanelItem/components/Shared/ScreenSelect';
import { Option } from 'components/ScreensPanelItem/components/Shared/ScreenSelect/models';
import { ScreenMap } from 'models';
import { getScreenTypesOptions } from 'utils/screenDefinitions/screenTypes';
import { ScreenTypeProps } from './models';

const ScreenType: React.FunctionComponent<ScreenTypeProps> = ({ screen, screenDefinitions, updateScreenType }) => {
  const currentScreenDefId = (screen as ScreenMap).get('screenDefinitionId');
  const currentScreenDef = screenDefinitions.get(currentScreenDefId);
  const currentScreenType = currentScreenDef.get('defaultName');

  const handleChange = (option: Option): void => {
    const screenDefId = option.value;

    updateScreenType(screen.get('id'), screenDefId);
  };

  const activeOption: Option = {
    value: currentScreenDefId,
    label: currentScreenType,
  };


  const options: Option[] = useMemo(
    () => getScreenTypesOptions(screenDefinitions),
    [screenDefinitions],
  );

  return (
    <ScreenSelect
      activeOption={activeOption}
      onChange={handleChange}
      options={options}
    />
  );
};

export default ScreenType;
